import React from 'react';
import { StyledInputPassword } from './index.styled';
import { InputProps } from 'antd';

type AppInputPasswordProps = InputProps & {
  allowCapitalize?: boolean;
  upperCaseAll?: boolean;
};

const AppInputPassword: React.FC<AppInputPasswordProps> = ({
  ...rest
}: AppInputPasswordProps) => {
  return <StyledInputPassword {...rest} />;
};
export default AppInputPassword;
